<template>
    <div class="pdf_page" v-if="invoiceUrl">
        <PdfPreview :pdfUrl="invoiceUrl" :pdfParam="pdfParam" :isIos="isIos"></PdfPreview>
    </div>
</template>
<script>
import PdfPreview from "./pdfPreview.vue";

export default {
  name: "InvoiceView",
  components: {
    PdfPreview
  },
  data() {
    return {
      pdfParam: {},
      invoiceUrl: null,
      isIos: true,
    };
  },
  mounted() {
    this.invoiceUrl = this.$route.query.invoiceUrl;
    this.pdfParam = this.$route.query.pdfParam;
  },
};
</script>

<style lang="less" scoped>
.invoice-tip-box {
  margin: 0 0;
  padding: 12px;
  font-size: 14px;
  background-color: #fff1f0;
  border: 1px solid #ffa39e;
  border-radius: 4px;
}
#waterStatistics-page {
  /deep/ .van-tabs--card > .van-tabs__wrap {
    height: 50px;
    background: "#fff";
    margin-bottom: 8px;
  }
  /deep/.van-tabs__nav--card .van-tab {
    box-sizing: border-box;
    color: #666666;
    font-size: 16px;
    border: none;
    border-radius: 16px;
    background: #f7f7f7;
    margin: 8px 5px;
    height: 32px;
  }

  /deep/.van-tabs__nav--card {
    border: none;
    height: 50px;
    margin: 0;
    padding-left: 10px;
  }
  /deep/ .van-tabs__nav--card .van-tab.van-tab--active {
    color: #4285f4;
    background-color: #e3edfe;
  }
  .user-info {
    position: relative;
    padding: 0 12px;
    height: 88px;
    ul {
      margin-left: 28px;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
      li:last-child {
        margin-top: 10px;
      }
    }
  }
  .meterlist {
    width: 100%;
    padding: 5px 10px;
    box-sizing: border-box;
    margin-top: 10px;
    .meterInfo {
      background-color: #fff;
      border-radius: 15px;
      box-shadow: 2px 2px 4px 0 rgba(213, 218, 225, 0.3);
      margin-bottom: 8px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .meter-img {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 44px;
        border-bottom: solid 1px #f2f1f6;
        margin-bottom: 12px;
      }
      .top-left {
        display: flex;
        align-items: center;
        .status-tag {
          padding: 2px 8px;
          color: #0acc9d;
          background: #0acc9d1a;
          border-radius: 4px;
          font-size: 13px;
        }
        .status-tag-undone {
          background: #18a5ff1a;
          color: #18a5ff;
        }
      }
      .meterAmount {
        width: 100%;

        .count {
          font-size: 14px;
          color: #666;
          width: 100%;
        }
        .count > div:first-child {
          margin-bottom: 10px;
          color: #000;
          font-size: 16px;
          font-weight: 500;
        }
      }
      .meter-right {
        color: #666;
        width: 100%;
        text-align: right;
      }
    }
    .meterInfo:last-child {
      margin-bottom: 0;
    }
  }
  .invoice-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 88px;
    height: 28px;
    border: 1px solid #4285f4;
    border-radius: 15px;
    font-size: 14px;
    color: #4285f4;
    margin-left: 8px;
  }
  .primary-btn {
    background: #4285f4;
    color: #fff;
  }
  .footer {
    position: fixed;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    bottom: 0;
    padding: 0 12px;
    .primary-btn {
      height: 36px;
      border-radius: 22px;
    }
  }
}
</style>